import Super from '../../../core/menu/item.gjs';

export default class SpdsInputDropdownListItem extends Super {
  variantClass = 'spds-input-dropdown-list-item';
}
